import {needAuth} from "../instance/Instance";
import {AxiosError} from "axios";
import {getParam} from "../../components/Utils/Utils";

const selectEquipment = async (search, pageable) => {
    console.log(">> 장비 반출입대장 List 조회")
    let pageStr="";
    let sort="sort=";
    let size='&size=';
    let page='&page=';
    const desc = ',desc';
    if(pageable.sort) {
        sort += pageable.sort
        if (pageable.desc) {

            sort += desc;
        }
    }

    if(pageable.size){
        size +=pageable.size;
    }
    page +=pageable.page;
    pageStr=sort+size+page;



    try {
        return await needAuth.post(`/equipment?`+pageStr, search);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const getServiceApply = async (id) => {
    try {
        return await needAuth.get(`/serviceApply/${id}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}
// async function createAsset(data) {
//     console.log(">>> api : 전산신 출입대장 등록")

//     const formData = new FormData();
//
//     formData.append(
//         "computerRoomRequestDto",
//         new Blob([JSON.stringify(data)], { type: "application/json" })
//     );
//     try{
//         return  await needAuth.post(
//             '/computerroom/create',
//             formData,
//             {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             }
//         );
//     }catch (error){
//         return error;
//     }
// }

async function createEquipment(data) {
    try{
        console.log(">>> api : 전산장비 반출입 등록");
        return  await needAuth.post('/equipment/create', data);
    }catch (error){
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


const updateServiceApply = async (data) => {
    try {
        return await needAuth.put(`/serviceApply`, data);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}

const deleteServiceApply = async (id) => {
    try {
        return await needAuth.put(`/serviceApply/${id}`);
    } catch (error) {
        if (error instanceof AxiosError) {
            const status = error.response.status;
            const data = error.response.data;
            return {status, data}
        }
    }
}


export {selectEquipment,createEquipment}

